import type { ExperienceKind } from "./experiences";
import type { PageDocument, PageNode, PageNodeCondition } from "./pages";

// Walking a page's element tree (see pages.ts), with no schema library, so a creator site's
// script stays small.

export function pageNodeChildren(node: PageNode): PageNode[] {
  return node.kind === "frame" || node.kind === "tabs" || node.kind === "accordion"
    ? node.children
    : node.kind === "collection" || node.kind === "item"
      ? node.template
      : node.kind === "liveMatchup"
        ? // A document stored before the form was made of elements is read without it.
          (node.children ?? [])
        : node.kind === "leagueHandbook" || node.kind === "leagueSection"
          ? node.children
          : [];
}

export function walkPageNodes(document: Pick<PageDocument, "nodes">): PageNode[] {
  const result: PageNode[] = [];
  function visit(nodes: PageNode[]) {
    for (const node of nodes) {
      result.push(node);
      visit(pageNodeChildren(node));
    }
  }
  visit(document.nodes);
  return result;
}

/** Whether an element shows for the features the site has on. Unconditional elements always do. */
export function pageNodeVisible(
  node: { when?: PageNodeCondition },
  enabled: ReadonlySet<ExperienceKind>,
) {
  return !node.when || enabled.has(node.when.feature) === node.when.enabled;
}
